import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import Chart from 'react-google-charts';

export default function OperationalReport() {
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Default to current month
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [chartData, setChartData] = useState([]);
    const [visitationData, setVisitationData] = useState([]);
    const visitData = {
        siteName: "",
        year: "",
        month: "",
        status: ""
    }

    useEffect(() => {
        const visitationApi = process.env.REACT_APP_VISITATION_GETALL;
        if (visitationApi)
            axios.post(visitationApi, visitData)
                .then((response) => response.json())
                .then((data) => setVisitationData(data))
                .catch((error) => console.error(error))
    }, []);
    useEffect(() => {
        // Filter data based on selected month and years
        const filteredData = visitationData.filter(
            (entry) => entry.month === selectedMonth && (entry.year === selectedYear || entry.year === selectedYear - 1)
        );

        // Prepare data for Google Chart
        const chartData = [['Sitename', 'Total Paid Visitation', 'Total Unpaid Visitation']];
        filteredData.forEach((entry) => {
            chartData.push([
                entry.sitename,
                entry.totalpaidvisitation,
                entry.totalunpaidvisitation
            ]);
        });

        setChartData(chartData);
    }, [selectedMonth, selectedYear, visitationData]);
    const paidVisitData = [
        ["SiteName", "FY 21/22", "FY 22/23", "% change"],
        ["Anthracite Heritage Museum", 198, 216, 9.1],
        ["Brandywine Battlefield Park", 200, 203, 1.5],
        ["Brandywine Battlefield Park", 206, 206, 0],
        ["Brandywine Battlefield Park", 201, 197, -2.0],
    ];
    const paidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const paidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: 3,
        },
    ];

    const unpaidVisitData = [
        ["SiteName", "FY 21/22", "FY 22/23", "% change"],
        ["Anthracite Heritage Museum", 198, 216, 9.1],
        ["Brandywine Battlefield Park", 200, 203, 1.5],
        ["Brandywine Battlefield Park", 206, 206, 0],
        ["Brandywine Battlefield Park", 201, 197, -2.0],
    ];
    const unpaidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const unpaidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: 3,
        },
    ];

    // Generate an array of years from 2015 to the current year
    const yearOptions = Array.from({ length: new Date().getFullYear() - 2014 }, (_, index) => 2015 + index);

    const handleMonthChange = (e) => {
        console.log(e.target.value);
        setSelectedMonth(e.target.value);
    };

    const handleYearChange = (e) => {
        setSelectedYear(parseInt(e.target.value, 10));
    };

    return (
        <>
            <span ><b>Operational Report </b> </span>
            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Title>Total Paid Visitation</Card.Title>
                        <Card.Body>
                            <Form>
                                <Row className="mb-0 main-content" >
                                    <Form.Group as={Col} >
                                        <Form.Label>Select Month</Form.Label>
                                        <Form.Select defaultValue={selectedMonth} value={selectedMonth} onChange={handleMonthChange}>
                                            <option>JANUARY</option>
                                            <option>FEBRAURY</option>
                                            <option>MARCH</option>
                                            <option>APRIL</option>
                                            <option>MAY</option>
                                            <option>JUNE</option>
                                            <option>JULY</option>
                                            <option>AUGUST</option>
                                            <option>SEPTEMBER</option>
                                            <option>OCTOBER</option>
                                            <option>NOVEMBER</option>
                                            <option>DECEMBER</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formYear">
                                        <Form.Label>Select Year:</Form.Label>
                                        <Form.Select defaultValue={selectedYear} value={selectedYear} onChange={handleYearChange}>
                                            {yearOptions.map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Col />
                                </Row>
                            </Form>

                            <Row className="mb-0 main-content" >
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={paidVisitData}
                                    options={paidVisitOptions}
                                    formatters={paidVisitFormatters}
                                    rootProps={{ 'data-testid': '1' }}
                                />
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Title>Total Unpaid Visitation</Card.Title>
                        <Chart
                            width={'100%'}
                            height={'100%'}
                            chartType="Table"
                            loader={<div>Loading Chart</div>}
                            data={unpaidVisitData}
                            options={unpaidVisitOptions}
                            formatters={unpaidVisitFormatters}
                            rootProps={{ 'data-testid': '1' }}
                        />

                    </Card>
                </Col>

            </Row>


        </>
    );
}